// src/beta/hooks/useBetaErrorBoundary.tsx
import { Component, ReactNode } from 'react';
import { Wordmark } from '@/beta/components/Wordmark';

interface State { error: Error | null; }

/** App-level error boundary — last resort. Renders a black screen with the
 *  wordmark and a link back to the legacy kiosk. */
export class BetaErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error('Beta error boundary caught:', error);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div
        data-vm-beta
        style={{
          minHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 'var(--vm-s-3)',
          background: '#000',
          color: 'var(--vm-warm-white)',
        }}
      >
        <div style={{ width: 280 }}>
          <Wordmark width={280} />
        </div>
        <p
          style={{
            color: 'var(--vm-stone)',
            fontSize: 11,
            letterSpacing: '0.3em',
            textTransform: 'uppercase',
            fontFamily: 'var(--vm-font-heading)',
          }}
        >
          Beta interface stopped responding
        </p>
        <a
          href="/"
          style={{
            color: 'var(--vm-red)',
            fontSize: 12,
            letterSpacing: '0.3em',
            textTransform: 'uppercase',
            fontFamily: 'var(--vm-font-heading)',
            textDecoration: 'none',
            border: '1px solid var(--vm-red)',
            padding: '12px 18px',
          }}
        >
          Open legacy kiosk →
        </a>
      </div>
    );
  }
}
